/* eslint-disable no-param-reassign */
import ExternalPlan from 'Classes/ExternalPlan';
import {
  convertResponse as convertPlanResponse,
  convertRequest as convertPlanRequest,
  savePlanHandler,
} from 'Helpers/Plan';

function convertRequest(plan) {
  const request = Object.assign(convertPlanRequest(plan), {
    id: `${plan.id}`,
    type: plan.externalPlanType,
  });
  request.attributes = Object.assign(request.attributes, {
    type: plan.externalPlanType,
    name: plan.planName,
    externalGoal: plan.externalGoal,
    children: plan.children,
  });
  return request;
}

function convertResponse(response) {
  let plan = new ExternalPlan();
  const { attributes } = response;
  plan = Object.assign(plan, convertPlanResponse(response));
  plan.planName = attributes.name;
  plan.url = attributes.url;
  return plan;
}

function savePlan(create, plan, set, update, next, onFailure = null) {
  return savePlanHandler(
    create,
    plan,
    set,
    update,
    next,
    onFailure,
    () => {},
    convertRequest,
    convertResponse,
  ).then((data) => {
    if (data !== undefined) {
      window.open(data.attributes.url, '_blank');
    }
  });
}

export { convertResponse, savePlan };
